export class Content { 
    $key: string; 
    contentType: string = null;
    eventId: string;
    filetype: string;
    contentFileUrl: string;
    name: string;
    sessionId: string;
    sizeInBytes: number;
    position:number;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/content.ts